import {UserManagement} from "@/api/modules/userManagement/UserManagement";

/**
 * Helper object for searching for accounts.
 */
export class AccountSearch {

    /**
     * Constructor
     * @param auth
     */
    constructor(auth) {

        this._auth = auth;
        this.isAccountLoading = false;
        if (this._auth == null){
            throw new Error("[e518755-ADM] Auth not provided!");
        }

        this._userManagement = new UserManagement(this._auth);

    }

    search(searchString) {

        return new Promise((resolve, reject) => {
            try {
                if (searchString == null) {
                    resolve([]);
                }

                if (searchString.length == 0) {
                    resolve([]);
                }

                return this._userManagement.searchAccounts(searchString).then(accounts => {
                    if (accounts == null) {
                        window.tracer.warn("[w831289-ADM] result returned is null (expected a valid array)");
                        resolve([]);
                    } else {
                        resolve(accounts);
                    }

                }).catch(e => {
                    window.tracer.error("[e910906-ADM] Error getting accounts")
                    if (e != null) {
                        window.tracer.error(e);
                    }

                    resolve([]);
                });
            } catch (e) {

                window.tracer.error("[e268485-ADM] Error");
                window.tracer.error(e);
                reject(e);
            }

        });
    }
}